// Mirrors backend/utils/medicalDataAccess.js. Organizations without authorization to
// handle patients' medical data have this permission denied for every role.
export const MEDICAL_DATA_PERMISSION = 'patient:viewmedicaldata';
